exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".wrap__3MA {\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n\n.entry__etX {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  margin-left: 20px;\n  padding: 0 10px;\n  color: #5f6773;\n  font-size: 14px;\n  cursor: pointer; }\n  .entry__etX svg {\n    fill: #5f6773;\n    margin-right: 6px; }\n  .entry__etX:hover {\n    color: #0092ff; }\n    .entry__etX:hover svg {\n      fill: #0092ff; }\n", ""]);
// Exports
exports.locals = {
	"wrap": "wrap__3MA",
	"entry": "entry__etX"
};